<script>
import { Menu, Submenu, MenuItem } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import HomeView from './views/HomeView.vue';
import AboutView from './views/AboutView.vue';
import ImmigrationView from './views/ImmigrationView.vue';
import VisaView from './views/VisaView.vue';
import PRCardView from './views/PRCardView.vue';
import AppealView from './views/AppealView.vue';
import StudyView from './views/StudyView.vue';
import NewsView from './views/NewsView.vue';
import ContactView from './views/ContactView.vue';

export default {
  name: 'App',
  components: {
    [Menu.name]: Menu,
    [Submenu.name]: Submenu,
    [MenuItem.name]: MenuItem,
    HomeView,
    AboutView,
    ImmigrationView,
    VisaView,
    PRCardView,
    AppealView,
    StudyView,
    NewsView,
    ContactView
  }
}
</script>

<template>
  <div id="app">
    <el-menu mode="horizontal" class="nav-menu">
      <div class="nav-container">
        <div class="logo">
          <img src="./assets/logo-a-1.png" alt="Logo">
        </div>
        <div class="menu-items">
          <el-menu-item index="1">
            <span @click="$router.push('/')">首页</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <span @click="$router.push('/about/company')">关于我们</span>
            </template>
            <el-menu-item index="2-1"><span @click="$router.push('/about/company')">公司介绍</span></el-menu-item>
            <el-menu-item index="2-2"><span @click="$router.push('/about/why-us')">为什么选择我们</span></el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title" >
              <span @click="$router.push('/immigration')">移民申请</span>
            </template>
            <el-submenu index="3-1">
              <template slot="title">EE快速通道</template>
              <el-menu-item index="3-1-1"><span @click="$router.push('/immigration/ee')">EE快速通道</span></el-menu-item>
              <el-menu-item index="3-1-2"><span @click="$router.push('/immigration/fsw')">FSW项目</span></el-menu-item>
              <el-menu-item index="3-1-3"><span @click="$router.push('/immigration/cec')">CEC项目</span></el-menu-item>
              <el-menu-item index="3-1-4"><span @click="$router.push('/immigration/fst')">FST项目</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3-2">
              <template slot="title">安省省提名OINP</template>
              <el-menu-item index="3-2-1"><span @click="$router.push('/immigration/oinp')">安省省提名OINP</span></el-menu-item>
              <el-menu-item index="3-2-2"><span @click="$router.push('/immigration/employer-sponsor')">安省雇主担保</span></el-menu-item>
              <el-menu-item index="3-2-3"><span @click="$router.push('/immigration/graduate')">安省硕士/博士毕业生类项目</span></el-menu-item>
              <el-menu-item index="3-2-4"><span @click="$router.push('/immigration/skilled-worker')">安省雇主需要的技术和经验类人才项目</span></el-menu-item>
              <el-menu-item index="3-2-5"><span @click="$router.push('/immigration/entrepreneur')">安省企业家移民</span></el-menu-item>
            </el-submenu>
            <el-menu-item index="3-3"><span @click="$router.push('/immigration/suv')">创业移民SUV</span></el-menu-item>
            <el-menu-item index="3-4"><span @click="$router.push('/immigration/self-employed')">自雇移民Self-employe</span></el-menu-item>
            <el-menu-item index="3-5"><span @click="$router.push('/immigration/rnip')">北方及偏远地区移民RNIP</span></el-menu-item>
            <el-menu-item index="3-6"><span @click="$router.push('/immigration/afip')">农业食品项目移民AFIP</span></el-menu-item>
            <el-menu-item index="3-7"><span @click="$router.push('/immigration/aip')">大西洋省份移民项目AIP</span></el-menu-item>
            <el-menu-item index="3-10"><span @click="$router.push('/immigration/caregivers')">护理人员项目Caregivers</span></el-menu-item>
            <el-submenu index="3-8">
              <template slot="title">香港居民特殊通道移民Pathway for HKP</template>
              <el-menu-item index="3-8-1"><span @click="$router.push('/immigration/hk-graduate')">加拿大境内香港毕业生项目</span></el-menu-item>
              <el-menu-item index="3-8-2"><span @click="$router.push('/immigration/hk-work-exp')">香港居民加拿大工作经验类项目</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3-9">
              <template slot="title">家庭团聚移民Sponsorship</template>
              <el-menu-item index="3-9-1"><span @click="$router.push('/immigration/family-reunion')">家庭团聚移民</span></el-menu-item>
              <el-menu-item index="3-9-2"><span @click="$router.push('/immigration/spouse-children')">担保配偶及子女</span></el-menu-item>
              <el-menu-item index="3-9-3"><span @click="$router.push('/immigration/parents-grandparents')">担保父母祖父母</span></el-menu-item>
              <el-menu-item index="3-9-4"><span @click="$router.push('/immigration/single-sponsor')">单身担保家庭成员</span></el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <span @click="$router.push('/visa')">签证服务</span>
            </template>
            <el-menu-item index="4-1"><span @click="$router.push('/visa/trv')">TRV临时居民签证</span></el-menu-item>
            <el-submenu index="4-2">
              <template slot="title">访问签证</template>
              <el-menu-item index="4-2-1"><span @click="$router.push('/visa/visitor')">旅游探亲签证Visitor Visa</span></el-menu-item>
              <el-menu-item index="4-2-2"><span @click="$router.push('/visa/super')">父母超级签证Super Visa</span></el-menu-item>
              <el-menu-item index="4-2-3"><span @click="$router.push('/visa/business')">商务签证Business Visitor Visa</span></el-menu-item>
            </el-submenu>
            <el-submenu index="4-3">
              <template slot="title">学习签证</template>
              <el-menu-item index="4-3-1"><span @click="$router.push('/visa/study')">学习签证</span></el-menu-item>
              <el-menu-item index="4-3-2"><span @click="$router.push('/visa/extension-restoration')">签证延期Extension与恢复Restorantion</span></el-menu-item>
              <el-menu-item index="4-3-3"><span @click="$router.push('/visa/sds')">学生直入计划SDS</span></el-menu-item>
              <el-menu-item index="4-3-4"><span @click="$router.push('/visa/visitor-to-study')">旅游签证转学习签证</span></el-menu-item>
            </el-submenu>
            <el-submenu index="4-4">
              <template slot="title">工作签证</template>
              <el-menu-item index="4-4-1"><span @click="$router.push('/visa/work-permit')">工作签证</span></el-menu-item>
              <el-menu-item index="4-4-2"><span @click="$router.push('/visa/lmia-work-permit')">LMIA工签</span></el-menu-item>
              <el-menu-item index="4-4-3"><span @click="$router.push('/visa/spouse-open-work-permit')">配偶开放工签 SOWP</span></el-menu-item>
              <el-menu-item index="4-4-4"><span @click="$router.push('/visa/pgwp')">毕业后工签 PGWP</span></el-menu-item>
              <el-menu-item index="4-4-5"><span @click="$router.push('/visa/coop-work-permit')">实习工签 Co-op</span></el-menu-item>
              <el-menu-item index="4-4-6"><span @click="$router.push('/visa/bowp')">桥梁工签 BOWP</span></el-menu-item>
              <el-menu-item index="4-4-7"><span @click="$router.push('/visa/imp')">国际人才流动项目 IMP</span></el-menu-item>
              <el-menu-item index="4-4-8"><span @click="$router.push('/visa/ict')">跨国企业员工内部派遣工签 ICT</span></el-menu-item>
              <el-menu-item index="4-4-9"><span @click="$router.push('/visa/hk-graduate-work-permit')">香港毕业生工签</span></el-menu-item>
            </el-submenu>
            <el-submenu index="4-5">
              <template slot="title">特殊证件申请</template>
              <el-menu-item index="4-5-1"><span @click="$router.push('/visa/reconsideration')">复议请求Reconsideration</span></el-menu-item>
              <el-menu-item index="4-5-2"><span @click="$router.push('/visa/prtd')">永久居住旅行证件 PRTD</span></el-menu-item>
              <el-menu-item index="4-5-3"><span @click="$router.push('/visa/trp')">临时居民许可 Temporary Resident Permit</span></el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">
              <span @click="$router.push('/prcard')">枫叶卡及入籍</span>
            </template>
            <el-menu-item index="5-1"><span @click="$router.push('/prcard/application')">枫叶卡申请及换新</span></el-menu-item>
            <el-menu-item index="5-2"><span @click="$router.push('/prcard/citizenship')">入籍申请</span></el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">
              <span @click="$router.push('/appeal')">移民及难民法庭上诉</span>
            </template>
            <el-menu-item index="6-1"><span @click="$router.push('/appeal/family')">担保家庭成员被拒上诉</span></el-menu-item>
            <el-menu-item index="6-2"><span @click="$router.push('/appeal/residency')">居住时间不足上诉</span></el-menu-item>
            <el-menu-item index="6-3"><span @click="$router.push('/appeal/deportation')">驱逐令上诉</span></el-menu-item>
            <el-menu-item index="6-4"><span @click="$router.push('/appeal/refugee')">难民申请及难民申请被拒上诉</span></el-menu-item>
            <el-menu-item index="6-5"><span @click="$router.push('/appeal/prra')">FRRA遣返前风险评估</span></el-menu-item>
          </el-submenu>
          <el-submenu index="7">
            <template slot="title">
              <span @click="$router.push('/study')">留学服务</span>
            </template>
            <el-menu-item index="7-1"><span @click="$router.push('/study/school-intro')">院校介绍</span></el-menu-item>
            <el-menu-item index="7-2"><span @click="$router.push('/study/school-application')">院校申请</span></el-menu-item>
            <el-menu-item index="7-3"><span @click="$router.push('/study/document-guidance')">文书指导</span></el-menu-item>
            <el-menu-item index="7-4"><span @click="$router.push('/study/ielts-training')">雅思托福考试培训</span></el-menu-item>
            <el-menu-item index="7-5"><span @click="$router.push('/study/interview-guidance')">面试辅导</span></el-menu-item>
          </el-submenu>
          <el-menu-item index="8">
            <span @click="$router.push('/news')">移民资讯</span>
          </el-menu-item>
          <el-menu-item index="9">
            <span @click="$router.push('/contact')">联系我们</span>
          </el-menu-item>
        </div>
      </div>
    </el-menu>
    <router-view />
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-left">
          <img src="./assets/logo-a-2.png" alt="Logo" class="footer-logo">
          <div class="contact-info">
            <h3>联系我们</h3>
            <p>电话: +1 647-785-6789</p>
            <p>邮箱: info@wingocanada.com</p>
            <p>地址: 9390 Woodbine Ave 2D8，Markham, ON L6C 0M5, Canada</p>
          </div>
        </div>
        <div class="footer-center">
          <img src="./assets/ewm.jpg" alt="二维码" class="qr-code">
          <p>扫码关注我们</p>
        </div>
        <div class="footer-right">
          <div class="social-links">
            <a href="#" target="_blank"><img src="./assets/f.svg" alt="Facebook"></a>
            <a href="#" target="_blank"><img src="./assets/鸟.svg" alt="Twitter"></a>
            <a href="#" target="_blank"><img src="./assets/相机.svg" alt="Instagram"></a>
            <a href="#" target="_blank"><img src="./assets/发送.svg" alt="Email"></a>
          </div>
          <p class="copyright">Copyright © 2019 Wingocanada Immigration Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="less">
.nav-menu {
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 70px;

  .nav-container {
    display: flex;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    padding: 0 20px;

    .logo {
      margin-right: 40px;
      img {
        height: 50px;
        width: auto;
        transition: transform 0.3s ease;
        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .menu-items {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      height: 100%;

      .el-menu-item, .el-submenu__title {
        font-size: 15px;
        height: 70px;
        line-height: 70px;
        padding: 0 20px;
        transition: all 0.3s ease;

        &:hover {
          color: #409EFF;
          background-color: rgba(64, 158, 255, 0.1);
        }
      }

      .el-submenu .el-menu-item {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
      }
    }
  }
}

#app {
  padding-top: 60px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.footer {
  margin-top: auto;
  background-color: #222;
  color: #fff;
  padding: 40px 0;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 20px;
  }

  .footer-left {
    flex: 1;
    max-width: 400px;

    .footer-logo {
      height: 60px;
      width: auto;
      margin-bottom: 20px;
    }

    .contact-info {
      h3 {
        margin-bottom: 15px;
        font-size: 18px;
      }

      p {
        margin: 8px 0;
        font-size: 14px;
      }
    }
  }

  .footer-center {
    flex: 1;
    text-align: center;
    max-width: 200px;

    .qr-code {
      width: 150px;
      height: 150px;
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
    }
  }

  .footer-right {
    flex: 1;
    max-width: 300px;
    text-align: right;

    .social-links {
      margin-bottom: 20px;

      a {
        margin-left: 15px;
        
        img {
          width: 24px;
          height: 24px;
          filter: invert(1);
          transition: opacity 0.3s;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .copyright {
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
